export const getDefinedLocations = (locations: Array<[number, number]|undefined>): Array<[number, number]> =>
	locations.filter((location: [number, number]|undefined) =>
		typeof location !== 'undefined') as Array<[number, number]>;